/* eslint-disable */
import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi';

import { FooterOverlay, Newsletter } from '../../components';
import { images } from '../../constants';
import './Footer.css';

const Footer = () => (
  <div className="app__footer section__padding" id="footer">
    <FooterOverlay />
    <Newsletter />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext" style={{fontFamily:"poppins"}}>Avantages:</h1>
        <img className='img' src={images.uber} />
        <img className='img' src={images.deliveroo} />
        <img  className='img' src={images.bein} />
      </div>

      <div className="app__footer-links_logo">
    <h1 className="title">Volcano</h1>
        <p className="p__opensans">&quot;Pour vous assurer un service de livraison rapide, nous travaillons en collaboration avec Uber Eats et Deliveroo&quot; et tous Nos produits sont Halal.</p>
        <img src={images.spoon} className="spoon__img" style={{ marginTop: 15 }} />
        <div className="app__footer-links_icons">
          <FiFacebook />
          <FiTwitter />
          <FiInstagram />
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Nos Horaires:</h1>
        <p className="p__opensans">Lundi - Jeudi:</p>
        <p className="p__opensans">De 11 h à 23 h</p>
        <p className="p__opensans">Vendredi</p>
        <p className="p__opensans">De 14 h à 01 h</p>
        <p className="p__opensans">Samedi - Dimanche</p>
        <p className="p__opensans">De 11 h à 23 h</p>
     

      </div>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">2023 Volcano made by ©Zakarialk01 All Rights reserved.</p>
    </div>

  </div>
);

export default Footer;
